import { NcLoadingIndicator } from "@noted/noted-components";
import { useEffect } from "react";

import { useAuth } from "~/components/auth-provider";
import { useLogoutTracker } from "~/components/auth-provider/use-logout-tracker";

function Logout() {
  const { logout } = useAuth();
  const startLogout = useLogoutTracker(state => state.startLogout);

  useEffect(() => {
    startLogout();
    logout().catch(() => console.error);
  }, [logout, startLogout]);

  return (
    <div className="flex h-screen items-center justify-center">
      <NcLoadingIndicator variant="logo" />
    </div>
  );
}

export default Logout;
